<script lang="ts" setup>
import { resources } from '../config/brands'
</script>

<template>
  <RouterLink to="/" class="flex items-center shrink-0" style="gap: 16px">
    <img :src="resources.logo || ''" alt="logo icon" style="width: 30px; height: 30px; object-fit: contain">
    <img :src="resources.novelText || ''" alt="logo text" style="height: 20px; width: auto; object-fit: contain">
  </RouterLink>
</template>
